import React, { Component } from "react";

export class MailingLabels extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    console.log(props);
  }
  componentDidMount() {
    setTimeout(() => {}, 1000);
  }
  render() {
    return (
      <main className="mailing-label-body">
        {this.props.state.clients.map((f, i) => {
          if (i % 30 === 0 && i !== 0) {
            return (
              <span>
                <div className="mailing-label-page-break"></div>
                <div className="page-break-tail"></div>
                <div className="label-avery-5160">
                  {f.name}
                  <br />
                  {f.line_1}
                  <br />
                  {f.line_2}
                </div>
              </span>
            );
          }
          return (
            <div className="label-avery-5160">
              {f.name}
              <br />
              {f.line_1}
              <br />
              {f.line_2}
            </div>
          );
        })}
      </main>
    );
  }
}

export default MailingLabels;
